import { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate, useParams } from "react-router-dom";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  getSaleRequestById,
  getSellById,
} from "../../../../../redux/sale/action";
import {
  Commas,
  getDateFormate,
} from "../../../../Common/AllDateTimeReleventFormate";
import SaleOrderstatus from "./SaleOrderstatus";
import useChatNavigation from "../../../../Common/useChatNavigation";
import HelpSupportModal from "../../../../Common/HelpSupport/HelpSupportModal";
import { Modal } from 'reactstrap';
import ModelContractPost from '../../../../Common/ContractandPost/ModelContractPost';
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";

export default function ProductforsaleDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { letChat } = useChatNavigation();
  const [theModal, setTheModal] = useState(false);
  const [contract, setContact] = useState(false);

  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  const od = useSelector(
    ({ sale: { getsalerequestbyid } }) => getsalerequestbyid
  );

  useEffect(() => {
    dispatch(getSaleRequestById(id));
  }, [id]);

  const customStyle = {
    fontWeight: "600",
    color: "#00245C",
  };
  return (
    <div className="productsale">
      <div className="mb-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: 'center',
        }}
      >
        <p className="breadcrumbs">
          <a onClick={() => navigate(-1)} style={{ color: "#ef7710" }}>
            Back &gt;{" "}
          </a>{" "}
          Product details
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <a
              onClick={() => setContact((state) => !state)}
              style={{ color: "#ef7710", cursor: "pointer", fontWeight: "600", textDecoration: "underline" }}
            >
              View contract
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/square-arrow.svg`}
                alt=""
                style={{ marginLeft: "5px" }}
              />
            </a>
          <button className="background-button btn" onClick={() => setTheModal(true)}>
            Dispute
          </button>
        </div>
      </div>
      <div className="row justify-content-between">
        <div className="col-md-5">
          <div className="productsale-first">
            <h2>Order ID: {od?.id}</h2>
            <div className="order-details">
              <h6>Order details</h6>
              <div className="orderdetails-p">
                <p>
                  {" "}
                  <span style={customStyle}>Order date :</span>{" "}
                  <span>{getDateFormate(od?.created_on)}</span>
                </p>
                <p>
                  {" "}
                  <span style={customStyle}>Total cost : </span>{" "}
                  <span>$ {Commas(od?.price)}</span>
                </p>
                <p>
                  {" "}
                  <span style={customStyle}>Shipping charges :</span>{" "}
                  <span>{od?.shipping == 2 ? "Not Included" : "Included"}</span>
                </p>
                <p>
                  {" "}
                  <span style={customStyle}>Quantity :</span>{" "}
                  <span>1 Piece</span>
                </p>
              </div>
            </div>
          </div>
          <div className="item-details">
            <h5>Item details</h5>
            <div className="professional">
              <img src={Array.isArray(od?.files) && od?.files[0]?.file} alt="" />
              <div>
                <h6>{od?.title}</h6>
                <h3>$ {Commas(od?.price)}</h3>
              </div>
            </div>
          </div>
          {od && (
            <div className="item-details buyer-info">
              <h5>{od?.is_mine == 0 ? "Seller" : "Buyer"} info </h5>
              <div className="professional ">
                <img src={od?.profile_image ? od?.profile_image : ProfilePic} alt="" />
                <div className="professional-left">
                      <div > 
                  
                    <h6>
                      {od?.first_name} {od?.last_name}
                    </h6>
                    <p className="location">
                      {" "}
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                        alt=""
                      />{" "}
                      {od?.country_title}{" "}
                    </p>
                  </div>
                  <div>
                    <p className="pb-1">{od?.email_id} </p>
                    <p>
                      {od?.country_code ? od?.country_code : ""}{" "}
                      {od?.mobile_number}{" "}
                    </p>
                  </div>
                </div>
              </div>
              <button
                className="buttons border-button "
                onClick={() => {
                  letChat(od);
                }}
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                  alt=""
                />{" "}
                Chat with {od?.is_mine == 0 ? "Seller" : "Buyer"}
              </button>
            </div>
          )}
        </div>
        {od?.status > 2 ? <SaleOrderstatus data={od} /> : od?.status == 2 ?
          <div className="col-md-5">
            <div className='status-rightsec reject-sts'>
              <h6>Rejected</h6>
            </div>
          </div>
          : ""}
      </div>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={contract}
        toggle={() => setContact((state) => !state)}
      >
        <ModelContractPost
          setContact={setContact}
          proposalmilestones={{ agreement_pdf: od?.agreement_pdf }}
        />
      </Modal>
      <HelpSupportModal
        theModal={theModal}
        setTheModal={setTheModal}
        data={od}
        masterID={id}
        masterType="3"
      />
    </div>
  );
}
